import { DollarSign, ArrowRight, CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

const SVC_FINANCE_URL =
  "https://apply.svcfin.com/home/dealerAuthentication?id=6501257295&key=1742219857";

interface FinancingCTAProps {
  variant?: "card" | "inline" | "prominent";
}

const FinancingCTA = ({ variant = "card" }: FinancingCTAProps) => {
  if (variant === "inline") {
    return (
      <a
        href={SVC_FINANCE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="w-full"
      >
        <Button variant="outline" size="lg" className="w-full">
          <DollarSign className="mr-2 h-5 w-5" />
          Apply for Financing
        </Button>
      </a>
    );
  }

  const isProminent = variant === "prominent";

  return (
    <div
      className={`rounded-2xl border-2 border-accent/40 bg-gradient-to-br from-accent/10 to-accent/5 p-6 ${
        isProminent ? "shadow-card" : "shadow-soft"
      }`}
    >
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-5">
        <div
          className={`flex shrink-0 items-center justify-center rounded-full bg-accent/15 ${
            isProminent ? "h-16 w-16" : "h-12 w-12"
          }`}
        >
          <DollarSign
            className={`text-accent ${isProminent ? "h-8 w-8" : "h-6 w-6"}`}
          />
        </div>
        <div className="flex-1">
          <h3
            className={`font-heading font-bold text-foreground mb-1 ${
              isProminent ? "text-2xl" : "text-lg"
            }`}
          >
            $0 Down Financing — Rates as Low as $100/Month
          </h3>
          <p
            className={`text-muted-foreground mb-3 ${
              isProminent ? "text-base" : "text-sm"
            }`}
          >
            Make your roofing project affordable with flexible monthly payments
            through our financing partner. Get approved fast and start your
            roof with no upfront cost.
          </p>
          <div className="flex flex-wrap items-center gap-3 mb-4">
            <span className="inline-flex items-center gap-1 text-xs font-semibold text-foreground bg-background/60 px-3 py-1 rounded-full border border-accent/20">
              <CheckCircle className="h-3 w-3 text-accent" />
              $0 down options
            </span>
            <span className="inline-flex items-center gap-1 text-xs font-semibold text-foreground bg-background/60 px-3 py-1 rounded-full border border-accent/20">
              <CheckCircle className="h-3 w-3 text-accent" />
              Low monthly payments
            </span>
            <span className="inline-flex items-center gap-1 text-xs font-semibold text-foreground bg-background/60 px-3 py-1 rounded-full border border-accent/20">
              <CheckCircle className="h-3 w-3 text-accent" />
              Fast approval
            </span>
          </div>
          <a
            href={SVC_FINANCE_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button
              variant={isProminent ? "accent" : "outline"}
              size={isProminent ? "lg" : "sm"}
              className={isProminent ? "group" : ""}
            >
              <DollarSign className="mr-1 h-4 w-4" />
              Apply for Financing
              <ArrowRight className="ml-1 h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </Button>
          </a>
          <p className="text-xs text-muted-foreground mt-2">
            Subject to credit approval. Terms and conditions apply.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FinancingCTA;

